// removed by extract-text-webpack-plugin
module.exports = {"layout":"src-display-modules-Home-Workbench2-index__layout--1OJ-O","sider":"src-display-modules-Home-Workbench2-index__sider--3ifBD","header":"src-display-modules-Home-Workbench2-index__header--3XMp3","content":"src-display-modules-Home-Workbench2-index__content--1G4x2","mL245":"src-display-modules-Home-Workbench2-index__mL245--3-9Jo","appBox":"src-display-modules-Home-Workbench2-index__appBox--37sGK","appBoxLong":"src-display-modules-Home-Workbench2-index__appBoxLong--EGaV4"};


//////////////////
// WEBPACK FOOTER
// ./src/display/modules/Home/Workbench2/index.scss
// module id = 7101
// module chunks = 0